export const PASSPORT_RULE = {
    type: 'passport',
    labelKey: 'identity.passport',
    label: 'Passport',
    pattern: '^(?=.*[A-Z])(?=.*[0-9])[A-Z0-9]{6,12}$',
    normalise: 'upper_alnum',
    checksum: 'none',
    onChecksumFail: 'warn',
    onPatternFail: 'refuse',
    needsIssuingCountry: true,
    nphiesSystemKey: 'passportNumber',
    example: 'AB1234567',
};
export const NO_DOCUMENT_RULE = {
    type: 'no_document',
    labelKey: 'identity.no_document',
    label: 'No document',
    pattern: '^$',
    normalise: 'upper_alnum',
    checksum: 'none',
    onChecksumFail: 'warn',
    onPatternFail: 'refuse',
    example: '',
};
export const COMMON_DOCUMENTS = [PASSPORT_RULE, NO_DOCUMENT_RULE];
//# sourceMappingURL=documents.js.map